import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { FacilitiesPage } from './pages/facilities/FacilitiesPage';
import { FederationsPage } from './pages/federations/FederationsPage';
import { GrantsPage } from './pages/grants/GrantsPage';
import { ArtistsPage } from './pages/artists/ArtistsPage';
import { PermitsPage } from './pages/permits/PermitsPage';
import { ArchivesPage } from './pages/archives/ArchivesPage';
import { CreolePage } from './pages/creole/CreolePage';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  // One workspace, not one-per-role — land each persona somewhere useful for
  // their primary duty rather than always defaulting to the same tab.
  const landing = persona.roles.includes('FACILITY_MANAGER')
    ? '/facilities'
    : persona.roles.includes('GRANTS_PANEL')
      ? '/grants'
      : persona.roles.includes('ARCHIVIST')
        ? '/archives'
        : persona.roles.includes('HERITAGE_OFFICER')
          ? '/permits'
          : '/federations';

  return (
    <Routes>
      <Route
        element={
          <Shell
            title="Youth, Sports & Culture"
            items={[
              { to: '/facilities', label: 'Facilities & Bookings', icon: '⚑' },
              { to: '/federations', label: 'Federations & Athletes', icon: '◎' },
              { to: '/grants', label: 'Grant Applications', icon: '⚑' },
              { to: '/artists', label: 'Artists & Opportunities', icon: '✦' },
              { to: '/permits', label: 'Event & Heritage Permits', icon: '☷' },
              { to: '/archives', label: 'National Archives', icon: '▤' },
              { to: '/creole', label: 'CreolePortal CMS', icon: '✎' },
            ]}
          />
        }
      >
        <Route index element={<Navigate to={landing} replace />} />
        <Route path="facilities" element={<FacilitiesPage />} />
        <Route path="federations" element={<FederationsPage />} />
        <Route path="grants" element={<GrantsPage />} />
        <Route path="artists" element={<ArtistsPage />} />
        <Route path="permits" element={<PermitsPage />} />
        <Route path="archives" element={<ArchivesPage />} />
        <Route path="creole" element={<CreolePage />} />
      </Route>

      <Route path="*" element={<Navigate to={landing} replace />} />
    </Routes>
  );
}
